/**
 * Created by intellicar-rinas on 23/11/17.
 */
class ContainsLatLng {
    constructor () {

        if (!window.google.maps.Polygon.prototype.getBounds) {
            window.google.maps.Polygon.prototype.getBounds = function(latLng) {
                var bounds = new window.google.maps.LatLngBounds(),
                    paths = this.getPaths(),
                    path,
                    p, i;

                for (p = 0; p < paths.getLength(); p++) {
                    path = paths.getAt(p);
                    for (i = 0; i < path.getLength(); i++) {
                        bounds.extend(path.getAt(i));
                    }
                }

                return bounds;
            };
        }

        window.google.maps.Circle.prototype.containsLatLng = function(latLng) {
            return this.getBounds().contains(latLng) && window.google.maps.geometry.spherical.computeDistanceBetween(this.getCenter(), latLng) <= this.getRadius();
        };

        // Polygon containsLatLng - method to determine if a latLng is within a polygon
        window.google.maps.Polygon.prototype.containsLatLng = function(latLng) {
            // Exclude points outside of bounds as there is no way they are in the poly

            var inPoly = false,
                bounds, lat, lng,
                numPaths, p, path, numPoints,
                i, j, vertex1, vertex2;

            // Arguments are a pair of lat, lng variables
            if (arguments.length == 2) {
                if (
                    typeof arguments[0] == "number" &&
                    typeof arguments[1] == "number"
                ) {
                    lat = arguments[0];
                    lng = arguments[1];
                }
            } else if (arguments.length == 1) {
                bounds = this.getBounds();

                if (!bounds && !bounds.contains(latLng)) {
                    return false;
                }
                lat = latLng.lat();
                lng = latLng.lng();
            } else {
                console.log("Wrong number of inputs in window.google.maps.Polygon.prototype.contains.LatLng");
            }

            // Raycast point in polygon method

            numPaths = this.getPaths().getLength();
            for (p = 0; p < numPaths; p++) {
                path = this.getPaths().getAt(p);
                numPoints = path.getLength();
                j = numPoints - 1;

                for (i = 0; i < numPoints; i++) {
                    vertex1 = path.getAt(i);
                    vertex2 = path.getAt(j);

                    if (
                        vertex1.lng() <  lng &&
                        vertex2.lng() >= lng ||
                        vertex2.lng() <  lng &&
                        vertex1.lng() >= lng
                    ) {
                        if (
                            vertex1.lat() +
                            (lng - vertex1.lng()) /
                            (vertex2.lng() - vertex1.lng()) *
                            (vertex2.lat() - vertex1.lat()) <
                            lat
                        ) {
                            inPoly = !inPoly;
                        }
                    }

                    j = i;
                }
            }

            return inPoly;
        }
    }
}

export default ContainsLatLng;